/**
 * State
 */
const state = {
    loqateAddresses: [],
    loqateAddress:null,
    loqateLatitude: null,
    loqateLongitude: null
};

/**
 * Getters
 */
const getters = {
    loqateAddresses: (state) => state.loqateAddresses,

    loqateAddress: (state) => state.loqateAddress,

    loqateLatitude: (state) => state.loqateLatitude,

    loqateLongitude: (state) => state.loqateLongitude
};

/**
 * Actions
 */
const actions = {

    findAddress({commit, getters}, {text, containerId}) {

        let urlString = `/api/v4/loqate/address-find?text=${text}&container=${containerId}&country_code=${getters.countryCodeSetting}`;

        return new Promise((resolve, reject) => {
            this.$axios.get(urlString).then(response => {
                commit('ADD_LOQATE_ADDRESSES', response.data.data);
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },

    retrieveLoqateAddress({commit}, addressFind) {
        return new Promise((resolve, reject) => {
            this.$axios.get(`/api/v4/loqate/address-retrieve/${addressFind.id}`).then(response => {
                commit('ADD_LOQATE_ADDRESS', response.data.data[0]);
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },

    loqateGeocode({commit, getters}, location) {
        return new Promise((resolve, reject) => {
            this.$axios.get(`/api/v4/loqate/geocode/${getters.countryCodeSetting}/${location}`).then(response => {

                commit('ADD_LOQATE_LAT_LONG', {
                    latitude: response.data.data.latitude,
                    longitude: response.data.data.longitude
                });
                
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    }
};

/**
 * Mutations
 */
const mutations = {
    ADD_LOQATE_ADDRESSES(state, addresses) {
        state.loqateAddresses = addresses;
    },

    ADD_LOQATE_ADDRESS(state, address) {
        state.loqateAddress = address;
    },

    ADD_LOQATE_LAT_LONG(state, {latitude, longitude}) {
        state.loqateLatitude = latitude;
        state.loqateLongitude = longitude;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}